module.exports = __webpack_public_path__ + "img/cash-register.41edb4b3.svg";